module.exports = __webpack_public_path__ + "static/media/Hybrid_Icon.6b7ae734.svg";